
<!-- Ball -->

<div class="ball-container" (mousemove)="showButtons()">

  <div #ball [ngStyle]="{'animation-play-state': ballstate}" (click)="playAudio()" class="ball">
  </div>
   
</div>  


<!-- Buttons + Timer Footer -->

<div [ngStyle]="{'opacity': showFooter}" class="buttons-container">

  <div class="timer">
    <span>00</span>:<span *ngIf="addzeros(minutes)">0{{minutes}}</span><span *ngIf="!addzeros(minutes)">{{minutes}}</span>:<span *ngIf="addzeros(seconds)">0{{seconds}}</span><span *ngIf="!addzeros(seconds)">{{seconds}}</span>
  </div>
 
  <div matRipple>
    <button (click)="toggle()" class="button" mat-raised-button color="##1f1f1f">
      <span *ngIf="!moving" class="material-icons">play_arrow</span>
      <span *ngIf="moving"class="material-icons">pause</span>
    </button>
    
  </div>

  <div matRipple><button (click)="resetTimer()" class="button" mat-raised-button color="#20BEA7"><span class="material-icons">replay</span></button></div>
  <div matRipple>
    <button (click)="toggleFullscreen()" class="button" mat-raised-button color="#20BEA7">
      <span *ngIf="!fullscreen" class="material-icons">fullscreen</span>
      <span *ngIf="fullscreen" class="material-icons">fullscreen_exit</span>
    </button>
  </div>
  <div matRipple><button (click)="showdialogue()" class="button" mat-raised-button color="#20BEA7"><span class="material-icons">close</span></button></div>


   
</div>

<!-- Start modal -->

<div *ngIf="startDialogue" class="dialogue-backdrop">
  <div class = "dialogue">
    <p class ="dialogue-text">Please select the duration of your session</p>
      <div class="dialogue-button-container">
    
          <div class="timeselector-container">
            <div class="plus-container">
              <button (click)="minutesUp()" class="plus"><span class="material-icons">keyboard_arrow_up</span></button>
            </div> 
              <div class="value-container">
                <input [(ngModel)]="minutes" class="value" type="text"/>
              </div>   
            <div class="plus-container">
              <button (click)="minutesDown()" class="plus"><span class="material-icons">keyboard_arrow_down</span></button>
            </div>
          </div>  

          <span style="padding: 0.5vw;">:</span>

          <div class="timeselector-container">
            <div class="plus-container">
              <button (click)="secondsUp()" class="plus"><span class="material-icons">keyboard_arrow_up</span></button>
            </div> 
              <div class="value-container">
                <input [(ngModel)]="seconds" class="value" type="text"/>
              </div>   
            <div class="plus-container">
              <button (click)="secondsDown()" class="plus"><span class="material-icons">keyboard_arrow_down</span></button>
            </div>
          </div>  

       </div>
       <div class="start"><button (click)="beginSession()" class="dialogue-button">Begin Session!</button></div>
  </div> 
</div> 

<!-- Close modal -->

<div *ngIf="showDialogue" class="dialogue-backdrop">
  <div class = "dialogue">
    <p class ="dialogue-text">Do you wish to end your session?</p>
      <div class="dialogue-button-container">
        <button routerLink="/chat" (click)="closeFullscreen()" class="dialogue-button margin-right">Yes</button>
        <button (click)="closedialogue()" class="dialogue-button margin-left">No</button>
      </div>
    </div> 
</div>


<!-- Session finished modal -->

<div *ngIf="sessionEnded" class="dialogue-backdrop">
  <div class = "dialogue">
    <p class ="dialogue-text">Your therapy session is completed!</p>
      <div class="dialogue-button-container">
        <button routerLink="/chat" (click)="closeFullscreen()" class="dialogue-button margin-right">Okay</button>
      </div>
    </div> 
</div>


  